import { getAppGlobals } from '~/components/AppGlobals/utils';

/**
 * Whether the dev Nectar analytics console should be active.
 */
export const isNectarConsoleEnabled = (): boolean => {
  try {
    const globals = getAppGlobals();
    const env = globals?.SENTRY_ENV;
    if (!env || env === 'production') {
      return false;
    }

    return globals?.VITE_SHOW_NECTAR_CONSOLE === 'true';
  } catch {
    return false;
  }
};
